function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0.888672 2.52356C0.888672 1.41899 1.7841 0.52356 2.88867 0.52356H22.8887C23.9932 0.52356 24.8887 1.41899 24.8887 2.52356V22.5236C24.8887 23.6281 23.9932 24.5236 22.8887 24.5236H2.88867C1.7841 24.5236 0.888672 23.6281 0.888672 22.5236V2.52356Z",
  fill: "#FDFDFD"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 8.83984,
  y: 8.02869,
  width: 9,
  height: 4,
  transform: "rotate(90 8.83984 8.02869)",
  fill: "black"
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 14.4391,
  y: 8.02869,
  width: 9,
  height: 4,
  transform: "rotate(90 14.4391 8.02869)",
  fill: "#444444"
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  x: 20.0383,
  y: 8.02869,
  width: 9,
  height: 4,
  transform: "rotate(90 20.0383 8.02869)",
  fill: "black"
});

var _ref6 = /*#__PURE__*/React.createElement("rect", {
  x: 3.2406,
  y: 8.02869,
  width: 9,
  height: 2.35193,
  transform: "rotate(90 3.2406 8.02869)",
  fill: "#444444"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M21.6373 9.52869L23.6373 12.5287L21.6373 15.5287",
  stroke: "black",
  strokeLinecap: "round"
});

function SvgScrollable(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScrollable);
export default __webpack_public_path__ + "static/media/scrollable.1e590f1a.svg";
export { ForwardRef as ReactComponent };